import React, { PureComponent } from 'react';

class SocialIcon extends PureComponent {
  render() {
    const { route, imgSrc } = this.props;

    return (
      <a href={route} className="hover:opacity-50 no-underline">
        <div
          style={{ backgroundImage: `url(${imgSrc})` }}
          className="
            w-12
            h-12
            bg-cover
            bg-center
          "
        />
      </a>
    );
  }
}

export default SocialIcon;
